/**
 * React component that showcases the latest inspirational boards
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import React, { useEffect, useMemo, useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import SectionHeader from '../SectionHeader'
import shuffle from 'lodash/shuffle'
import BoardCardsGrid from 'client/app/js/components/BoardCardsGrid'
import exploreApi from 'client/shared/js/services/explore/api'
import useMediaQuery from 'client/shared/js/hooks/useMediaQuery'
import { logError } from 'client/shared/js/utils/browser'
import styles from './BoardInspirations.module.scss'

const BoardInspirations = ({ className }) => {
  const [trips, setTrips] = useState(null)
  const { isTablet } = useMediaQuery()

  useEffect(() => {
    getPopularBoards()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getPopularBoards = useCallback(() => {
    exploreApi.getPopularBoards(0, 6)
      .then(({ data }) => (setTrips(data)))
      .catch((err) => {
        logError('Landing Page Popular Boards Error', err)
        setTrips({})
      })
  }, [])

  // Ensures we have a limit on the boards we show for mobile, with some randomness
  const filteredBoardsOrder = useMemo(() => {
    const boardsOrder = shuffle(trips?.boardsOrder || [])

    return isTablet ? boardsOrder.slice(0, 3) : boardsOrder
  }, [trips, isTablet])

  // TODO: replace explore all link
  return (
    <section className={cx(className)}>
      <SectionHeader
        title='Get inspired'
        description='View trips our users have taken and get ideas for your next vacation.' />
      <div className={cx(styles['boards-grid-container'])}>
        <BoardCardsGrid
          boards={trips?.boards}
          boardsOrder={filteredBoardsOrder}
          isLoading={!trips}
          anchor
          disableFavorite />
      </div>
    </section>
  )
}

BoardInspirations.propTypes = {
  className: PropTypes.string
}

export default BoardInspirations
